<template>
    <div>
        <ns-loader
            :fetch-timer="null"
            :to-load="toLoad"
            @dataFetched="onDataFetched"
            ref="measureLoader"
        >
            <template slot="content">
                <div>
                    <p>Seules les périodes communes entre tous les fichiers de mesures sont affichées</p>

                </div>
                <hr>
                <div
                    v-if="noIntersection"
                >
                    <p>Au moins un des fichiers de mesures n'a pas de période commune avec le reste des fichiers</p>
                </div>
                <el-form
                    label-position="top"
                    v-else
                >
                    <div class="range-form-container">
                        <el-form-item
                            label="Plage"
                        >
                            <el-slider 
                                v-model="dateRange" 
                                range
                                :min="min"
                                :max="max"
                                :marks="marks"
                                :format-tooltip="formatTooltip"
                            ></el-slider>
                            <el-date-picker
                                v-model="dateRange"
                                type="datetimerange"
                                format="dd/MM/yyyy HH:mm"
                                value-format="timestamp"
                                placeholder="Date de début"
                            ></el-date-picker>
                        </el-form-item>
                        <div>
                            
                        
                        
                        </div>
                        <div>
                            <el-form-item
                                label="Pas de temps"
                            >
                                <el-radio-group
                                    v-model="timeStep"
                                >
                                    <el-radio
                                        :label="1"
                                    >
                                        1min
                                    </el-radio>
                                    <el-radio
                                        :label="10"

                                    >
                                        10min
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div>
                            <el-button @click="closeModal()">Annuler</el-button>
                            <el-button type="primary" @click="startCalculations()">Lancer les calculs</el-button>
                        </div>
                    </div>
                </el-form>
            </template>
        </ns-loader>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loaderV2';
import moment from 'moment-timezone';
export default{
    name: 'SimulationRangeModal',
    components:{
        NsLoader
    },
    data(){
        return {
            noIntersection: false,
            formatTooltip: (dateMs)=>moment(dateMs).format('DD/MM/YYYY HH:mm'),
            dateRange: [0,0],
            timeStep: 1,
            marks: {
                0: '',
                100: ''
            },
            min: 0,
            max: 0,
        }
    },
    computed:{
        ...mapGetters(['allMeasureFilesUids', 'currentSite']),
            toLoad() {
                return [
                    {
                        name: 'measures',
                        model: 'simulationMeasureImportRequests',
                        filters: {
                            uid__in: this.allMeasureFilesUids,
                        },
                    },
                ]
            },
    },
    methods:{
        onDataFetched(res){
            let allDateRanges = res.measures.map(measure => [
                moment(measure.requested_start_date)
                .tz("Europe/Paris")
                .format("YYYY-MM-DDTHH:mm"),
                moment(measure.requested_end_date)
                .tz("Europe/Paris")
                .format("YYYY-MM-DDTHH:mm")
            ])
            
            this.computePeriod(allDateRanges)
        },
        closeModal(){
            this.noIntersection = false;
            this.timeStep = 1;
            this.min = 0;
            this.max = 0;
            this.dateRange = [0,0];
            this.marks = {
                0: '',
                100: ''
            };
            this.$emit('close-range-modal');
        },
        computePeriod(ranges) {
            // Convertir en moment
            const startMoments = ranges.map(r => moment(r[0]));
            const endMoments = ranges.map(r => moment(r[1]));

            // Min absolu des starts et max absolu des ends
            const earliestStart = moment.min(startMoments);
            const latestEnd = moment.max(endMoments);

            // Intersection commune : max(start), min(end)
            const maxStart = moment.max(startMoments);
            const minEnd = moment.min(endMoments);

            const hasIntersection = maxStart.isBefore(minEnd) || maxStart.isSame(minEnd);

            if (hasIntersection) {
                this.min = maxStart.valueOf(); // début commun
                this.max = minEnd.valueOf();   // fin commune
                this.dateRange = [this.min, this.max];

                this.$set(this, 'marks', {
                    0: maxStart.toISOString(),
                    100: minEnd.toISOString()
                });
            } else {
                this.noIntersection = true;
            }
        },
        startCalculations(){
            const utcStart = moment(this.dateRange[0])
            .tz("Europe/Paris")
            .utc()
            .format();
            
            const utcEnd = moment(this.dateRange[1])
            .tz("Europe/Paris")
            .utc()
            .format();


            this.$store.dispatch('createItem', {
                item: {
                    start_date: utcStart,
                    end_date: utcEnd,
                    measure_files_uid: this.allMeasureFilesUids,
                    related_site_uid: this.currentSite.uid,
                    time_step: this.timeStep,
                    status: 'PENDING'
                },
                model: 'simulations',
                url: this.$store.state.api.meta.listModels.simulations.url,
            }).then(simulation => {
                this.$notify({
                    title: 'Succès',
                    message: 'La simulation a été lancée',
                    type: 'success'
                });
                this.$emit('simulationCreated', simulation);
                this.closeModal();
            }).catch(() => {
                this.$notify({
                    title: 'Erreur',
                    message: "La simulation n'a pas pu être lancée",
                    type: 'error'
                });
            });
        },
    }
}
</script>

<style lang="scss">
    .range-form-container{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .el-form-item{
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            &:first-child{
                margin-right: 20px;
            }
            &:last-child{
                margin-left: 20px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/partials/simulation/SimulationRangeModal.vue